// Constants for Gigs
export const FETCH_GIGS_REQUEST = "FETCH_GIGS_REQUEST";
export const FETCH_GIGS_SUCCESS = "FETCH_GIGS_SUCCESS";
export const FETCH_GIGS_FAIL = "FETCH_GIGS_FAIL";

export const APPLY_GIG_REQUEST = "APPLY_GIG_REQUEST";
export const APPLY_GIG_SUCCESS = "APPLY_GIG_SUCCESS";
export const APPLY_GIG_FAIL = "APPLY_GIG_FAIL";

// gigsConstants.js

export const ADD_GIG_REQUEST = "ADD_GIG_REQUEST";
export const ADD_GIG_SUCCESS = "ADD_GIG_SUCCESS";
export const ADD_GIG_FAIL = "ADD_GIG_FAIL";


export const CLEAR_ERRORS = "CLEAR_ERRORS";
